<template>
	<div class="redeem b-bj-f2">
		<div class="redeem-view">
			<img class="logo" src="https://cdn.zxzx119.com/zxzx-mall-applet/activity/redeemCode/logo.png" alt="" srcset="" />
			<div class="title b-size-28 b-color-000">
				请使用微信扫描二维码<br>参与礼品兑换
			</div>
			<div class="liucheng">
				<image class="liucheng-img" src="https://cdn.zxzx119.com/zxzx-mall-applet/activity/redeemCode/list.png"></image>
			</div>
			<!-- <a class="btn" v-if="show" @click="openApp">
				点击打开APP
			</a> -->
		</div>
	</div>
	
</template>

<script>
	import {mapGetters,mapActions,mapState,mapMutations} from "vuex";
	export default {
		data() {
			return {
				show : false
			};
		},
		created() {
			console.log(this.utils.isIphoneOrPc())
			if(this.utils.isIphoneOrPc()=='phone'){
				this.show = true
			}
		},
		methods:{
			openApp(){
				window.open('to_zx_shop://com.zxzx_app.shopping/info_page')
			}
		},
		
	}
</script>

<style lang="scss" scoped>
.redeem{
	position: fixed;
	height: 100%;
	width: 100%;
	top: 0;
	left: 0;
	background: #fff;
	.btn{
		height: 44px;
		width: 200px;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 22px;
		font-size: 16px;
		background: #9D0536;
		margin: 30px auto;
		color: #fff;
	}
	&-view{
		width: 100%;
		height:100%;
		background: url('https://cdn.zxzx119.com/zxzx-mall-applet/activity/redeemCode/bg.jpg') no-repeat;
		background-size: 100% 100%;
		text-align: center;
		position: relative;
		.logo{
			position: relative;
			width: 160px;
			margin: 130px 0 45px 0;
		}
        .title{
            font-size: 28px;
            font-weight: bold;
            margin: 0 30px;
            color: #808080;
        }
		
	}
	
}
</style>



// WEBPACK FOOTER //
// src/view/activity/redeemCode.vue